import { render, staticRenderFns } from "./UpcomingBattleInfo.vue?vue&type=template&id=d2056364&scoped=true&"
import script from "./UpcomingBattleInfo.vue?vue&type=script&lang=ts&"
export * from "./UpcomingBattleInfo.vue?vue&type=script&lang=ts&"
import style0 from "./UpcomingBattleInfo.vue?vue&type=style&index=0&id=d2056364&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2056364",
  null
  
)

export default component.exports